/* ============================================================
   MAGNUM HOME & WINE – Schnellbestellung auf der Produktkarte
   Datei: assets/mgn-card.js

   Aufgabe: Wenn der Kunde 1 / 3 / 6 / 12 waehlt, wird die gewaehlte
   Flaeche hervorgehoben und der Preisblock oben in der Karte zeigt
   das gewaehlte Angebot (Preis, Grundpreis, Set-Zettel).
   24.09.2026 (E3, Gaby): Preisblock wechselt mit; die fruehere
   Rechenzeile unter den Knoepfen ist entfallen. Die Preisbloecke
   zeichnet snippets/mgn-card-pricebox vor, je Angebot ein <template>.

   Ein einziger Zuhoerer am Dokument bedient alle Karten der Seite
   (auch die, die "Mehr laden" spaeter nachlaedt).
   ============================================================ */
(function () {
  if (window.__mgnCardInit) return;
  window.__mgnCardInit = true;

  function show(input) {
    var group = input.closest('.mgn-seg');
    if (group) {
      var options = group.querySelectorAll('.mgn-seg__opt');
      for (var i = 0; i < options.length; i++) {
        options[i].classList.remove('is-on');
      }
      var chosen = input.closest('.mgn-seg__opt');
      if (chosen) chosen.classList.add('is-on');

      var card = input.closest('.mgn-card');
      var box = card ? card.querySelector('.mgn-card__pricebox') : null;
      var tpl = card && card.querySelector('.mgn-card__pricetpl[data-variant="' + input.value + '"]');
      if (box && tpl) box.innerHTML = tpl.innerHTML;
    }
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('.mgn-seg input[name="id"]')) return;
    show(input);
  });

  /* Zurueck-Knopf: der Browser stellt die gewaehlte Menge wieder her,
     den Preisblock aber nicht – deshalb nachziehen. */
  window.addEventListener('pageshow', function () {
    var checked = document.querySelectorAll('.mgn-seg input[name="id"]:checked');
    for (var i = 0; i < checked.length; i++) show(checked[i]);
  });
})();
